import { render, staticRenderFns } from "./AtomProjectSliderThumb.vue?vue&type=template&id=4cd2877d&scoped=true&"
import script from "./AtomProjectSliderThumb.vue?vue&type=script&lang=js&"
export * from "./AtomProjectSliderThumb.vue?vue&type=script&lang=js&"
import style0 from "./AtomProjectSliderThumb.vue?vue&type=style&index=0&id=4cd2877d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd2877d",
  null
  
)

/* custom blocks */
import block0 from "@/lang/SectionBrochure.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fatoms%2Fportfolio%2FAtomProjectSliderThumb.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports